<template>
  <div class="form-container">
    <form @submit.prevent="handleSubmit">
      <!-- 公司名称 -->
      <div class="form-group">
        <!-- <label>Company *</label> -->
        <input
          v-model="form.company"
          type="text"
          placeholder="Company"
          :class="{ 'error-border': errors.company }"
        />
        <span v-if="errors.company" class="error-msg">{{ errors.company }}</span>
      </div>

      <!-- 活动类型 -->
      <div class="form-group">
        <!-- <label>Type of Event *</label> -->
        <!-- <select
          v-model="form.eventType"
          class="selectNot"
          :class="{ 'error-border': errors.eventType,'unselected-state': !form.eventType }"
        >
          <option class="selectNo" value="" disabled>Type of event</option>
          <option v-for="type in eventTypes" :key="type" :value="type">
            {{ type }}
          </option>
        </select> -->
        <input
          v-model="form.eventType"
          type="text"
          placeholder="Type of event"
          :class="{ 'error-border': errors.eventType }"
        />
        <span v-if="errors.eventType" class="error-msg">{{ errors.eventType }}</span>
      </div>

      <!-- 邮箱 -->
      <div class="form-group">
        <!-- <label>Email *</label> -->
        <input
          v-model="form.email"
          type="email"
          placeholder="Email"
          :class="{ 'error-border': errors.email }"
        />
        <span v-if="errors.email" class="error-msg">{{ errors.email }}</span>
      </div>

      <!-- 电话 -->
      <div class="form-group">
        <!-- <label>Phone *</label> -->
        <input
          v-model="form.phone"
          type="tel"
          placeholder="Phone"
          :class="{ 'error-border': errors.phone }"
        />
        <span v-if="errors.phone" class="error-msg">{{ errors.phone }}</span>
      </div>

      <!-- message -->
      <div class="form-group">
        <textarea
          v-model="form.messageName"
          placeholder="Message"
          class="input-textarea"
          :class="{ 'error-border': errors.messageName }"
        />
        <span v-if="errors.messageName" class="error-msg">{{ errors.messageName }}</span>
      </div>

      <button type="submit" class="submit-btn" :disabled="isSending">
        {{ isSending ? 'Sending...' : 'Send Message' }}
      </button>
      
      <!-- 状态提示 -->
      <div v-if="sendStatus" class="status-message" :class="sendStatus.type">
        {{ sendStatus.message }}
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import emailjs from '@emailjs/browser';

// 配置EmailJS参数（需要提前注册获取）
const serviceID = 'service_knx0iw7';
const templateID = 'template_y6tjxev';
const publicKey = 'Sv12GaijrWRDSThAY';

const eventTypes = [
  'Conference',
  'Seminar',
  'Product Launch',
  'Networking Event',
  'Workshop'
];

const form = reactive({
  company: '',
  eventType: '',
  email: '',
  phone: '',
  messageName: ''
});

const errors = reactive({
  company: '',
  eventType: '',
  email: '',
  phone: '',
  messageName: ''
});

const isSending = ref(false);
const sendStatus = ref(null);

// 验证规则
const validateForm = () => {
  let isValid = true;
  const newErrors = { company: '', eventType: '', email: '', phone: '',messageName: '' };

  if (!form.company.trim()) {
    newErrors.company = 'Company name is required';
    isValid = false;
  }

  if (!form.eventType) {
    newErrors.eventType = 'event type is required';
    isValid = false;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!form.email) {
    newErrors.email = 'Email is required';
    isValid = false;
  } else if (!emailRegex.test(form.email)) {
    newErrors.email = 'Invalid email format';
    isValid = false;
  }

  const phoneRegex = /^\d{7,15}$/;
  if (!form.phone) {
    newErrors.phone = 'Phone number is required';
    isValid = false;
  }
  //  else if (!phoneRegex.test(form.phone)) {
  //   newErrors.phone = 'Invalid phone number (7-15 digits)';
  //   isValid = false;
  // }

  if (!form.messageName.trim()) {
    newErrors.messageName = 'messageName is required';
    isValid = false;
  }

  Object.assign(errors, newErrors);
  return isValid;
};

// 提交处理
const handleSubmit = async () => {
  if (!validateForm()) return;

  isSending.value = true;
  sendStatus.value = null;
  // to_email: 'frank@uaec-expo.com',

  try {
    await emailjs.send(
      serviceID,
      templateID,
      {
        to_email: 'frank@uaec-expo.com',
        company: form.company,
        event_type: form.eventType,
        email: form.email,
        phone: form.phone,
        messageName: form.messageName
      },
      publicKey
    );

    sendStatus.value = {
      type: 'success',
      message: 'Message sent successfully!'
    };
    
    // 清空表单
    Object.assign(form, {
      company: '',
      eventType: '',
      email: '',
      phone: '',
      messageName: ''
    });
    
  } catch (error) {
    console.error('Email send failed:', error);
    sendStatus.value = {
      type: 'error',
      message: 'Failed to send message. Please try again later.'
    };
  } finally {
    isSending.value = false;
  }
};
</script>

<style scoped>
.form-container {
  margin: 2rem auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.form-group {
  margin-bottom: 16px;
  overflow: hidden;
}

.input-textarea {
  height: 144px;
  width: 448px;
  box-sizing: border-box;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #2c3e50;
}

input, select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

input:focus, select:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52,152,219,0.25);
}

.error-border {
  border-color: #e74c3c !important;
}

select.unselected-state {
  background-color: #f8f9fa;
  color: #6c757d;
  border-color: #dee2e6;
  cursor: not-allowed;
}

select.unselected-state option:first-child {
  color: #adb5bd;
}

select.unselected-state:focus {
  box-shadow: 0 0 0 3px rgba(222,226,230,0.25);
}

.error-msg {
  display: block;
  margin-top: 0.5rem;
  color: #e74c3c;
  font-size: 0.875rem;
}

.submit-btn {
  width: 100%;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s ease;
  margin-top: 10px;


  display: flex;
  padding: 12px 10px 12px 20px;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  background: #FFD342;

  color: #504319;
font-family: Arial;
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 150%; /* 24px */
text-transform: capitalize;
}

.submit-btn:hover {
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.40) 0%, rgba(255, 255, 255, 0.40) 100%), #FFD342;
}

.submit-btn:active {
  transform: scale(0.98);
}
/* 之前的样式保持不变，新增状态提示样式 */
.status-message {
  margin-top: 10px;
  padding: 1rem;
  border-radius: 4px;
  text-align: center;
}

.status-message.success {
  background: #dff0d8;
  color: #3c763d;
  border: 1px solid #d6e9c6;
}

.status-message.error {
  background: #f2dede;
  color: #a94442;
  border: 1px solid #ebccd1;
}


/* 原有样式保持不变，新增textarea样式 */
textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 1rem;
  font-family: inherit;
  line-height: 1.5;
  transition: border-color 0.3s ease;
}

textarea:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52,152,219,0.25);
}

.selectNo {
  color: #ced4da;
}

select:not(.selectNot) {
  color: #ced4da !important;
}
</style>
